import { render } from "./OverviewCompanyBlock.vue?vue&type=template&id=ea8ae7bc&scoped=true"
import script from "./OverviewCompanyBlock.vue?vue&type=script&lang=js"
export * from "./OverviewCompanyBlock.vue?vue&type=script&lang=js"

import "./OverviewCompanyBlock.vue?vue&type=style&index=0&id=ea8ae7bc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea8ae7bc"]])

export default __exports__